import App from "./App";
import React from "react";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

import Home from "./pages/Home";
import { Login } from "./pages/auth/Login";
import { Signup } from "./pages/auth/SignUp";
import { Timeout } from "./pages/auth/Timeout";
import { FAQs } from "./pages/help/FAQs";
// import { PasswordReset } from "./pages/auth/PasswordReset.js";
import Pricing from "./pages/content/Pricing";
import Administration from "./pages/content/Administration";
import AdministrationUsers from "./pages/content/AdministrationUsers";
import AdministrationSecurity from "./pages/content/AdministrationSecurity";
import AdministrationSupport from "./pages/content/AdministrationSupport";
import AdministrationFlags from "./pages/content/AdministrationFlags";
import AdministrationAnalytics from "./pages/content/AdministrationAnalytics";
import AdministrationComms from "./pages/content/AdministrationComms";
import Profile from "./pages/auth/Profile.js";
import Help from "./pages/help/Help";
import About from "./pages/content/About";
import Contact from "./pages/content/Contact";
import Dashboard from "./pages/interview/Dashboard.js";
import Error from "./pages/Error";
import HomeTab from "./pages/interview/HomeTab.js";
import RecordingsTab from "./pages/interview/RecordingsTab.js";
import HubTab from "./pages/interview/HubTab.js";
import QuestionsIndex from "./pages/interview/QuestionsIndex.js";
import QuestionsDetail from "./pages/interview/QuestionsDetail.js";
import QuestionsLayout from "./pages/interview/QuestionsLayout.js";
import ProtectedRoute from "./routes/ProtectedRoute.js";
import AdminGate from "./routes/AdminGate.js";
import MocksTab from "./pages/interview/MocksTab.js";
import HelpRoutes from "./pages/help/HelpRoutes.js";
import RecordingDetailPage from "./pages/interview/RecordingDetailPage.js";
import "./styles/stylesheet.scss";

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            { index: true, element: <Home /> },
            { path: "*", element: <Error /> },
            // { path: "/sign-up", element: <Signup /> },
            { path: "/timeout", element: <Timeout /> },
            { path: "/about", element: <About /> },
            { path: "/contact", element: <Contact /> },
            { path: "/faqs", element: <FAQs /> },
            { path: "/pricing", element: <Pricing /> },
            { path: "/help", element: <Help /> },
            { path: "/help/*", element: <HelpRoutes /> },
            // {
            //     path: "/login",
            //     element: <Login />,
            //     children: [
            //         {
            //             path: "login/forgot-password/reset",
            //             element: <PasswordReset />,
            //         },
            //     ],
            // },
            {
                element: <ProtectedRoute />,
                children: [
                    {
                        path: "/profile",
                        element: <Profile />,
                    },
                    {
                        element: <AdminGate />,
                        children: [
                            {
                                path: "/administration",
                                element: <Administration />,
                            },
                            {
                                path: "/administration/users",
                                element: <AdministrationUsers />,
                            },
                            {
                                path: "/administration/security",
                                element: <AdministrationSecurity />,
                            },
                            {
                                path: "/administration/support",
                                element: <AdministrationSupport />,
                            },
                            {
                                path: "/administration/flags",
                                element: <AdministrationFlags />,
                            },
                            {
                                path: "/administration/analytics",
                                element: <AdministrationAnalytics />,
                            },
                            {
                                path: "/administration/comms",
                                element: <AdministrationComms />,
                            },
                        ],
                    },
                    {
                        path: "/dashboard",
                        element: <Dashboard />,
                        children: [
                            {
                                index: true,
                                element: <HomeTab />,
                            },
                            {
                                path: "recordings",
                                element: <RecordingsTab />,
                            },
                            {
                                path: "mocks",
                                element: <MocksTab />,
                            },
                            {
                                path: "career-hub",
                                element: <HubTab />,
                            },
                            {
                                path: "questions",
                                element: <QuestionsLayout />,
                                children: [
                                    {
                                        index: true,
                                        element: <QuestionsIndex />,
                                    },
                                    {
                                        path: ":qid",
                                        element: <QuestionsDetail />,
                                    },
                                    {
                                        path: ":qid/recording/:recordingId",
                                        element: <RecordingDetailPage />,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
]);

const root = createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            }}
        >
            <RouterProvider router={router} />
        </Auth0Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
